import { useCallback } from 'react';

import { getBrowserFeatureCheckUtil } from '../../main/utils/browser-feature-check.util';

export const useCompatibilityCheck = (): (() => boolean) => {
  return useCallback(() => {
    return getBrowserFeatureCheckUtil().supportsSpeechRecognition();
  }, []);
};
